module.exports = __webpack_public_path__ + "static/img/whitetitle3.8b058fc5.png";